// modify the events to be passive by default
var eventNames = ["touchstart", "touchmove", "wheel", "mousewheel"];

eventNames.forEach(eventName => {
    jQuery.event.special[eventName] = {
        setup: function (_, ns, handle) {
            this.addEventListener(eventName, handle, { passive: !ns.includes("noPreventDefault") });
        }
    };
});
